import { StepGamesType } from ".";
import Style from "./assets/Style.module.scss";

type InstructionsProps = {
  setStartGame: React.Dispatch<React.SetStateAction<StepGamesType>>;
};

export const Instruction: React.FC<InstructionsProps> = ({ setStartGame }) => {
  return (
    <div className={Style.modalContainer}>
      <div className={Style.modal}>
        <div className='text-center'>
          <h2>Este juego fue creado por Giuliano Antonanzas</h2>
          <p>
            <strong>
              Si es que te gusto el juego ,por favor saludalo y comentale que
              tal te fue!
            </strong>
          </p>

          <p>
            El juego consiste en hacer click a los planetas que se te apareceran
            en la pantalla. Estate atento, algunos tienen movimientos fuera de
            este galaxia.
          </p>

          <button
            className='btn btn-dark'
            onClick={() => setStartGame("startGame")}>
            ¡Empezar!
          </button>
        </div>
      </div>
    </div>
  );
};
